import type {
  SetPasswordMutation,
  SetPasswordMutationVariables
} from './__generated__/SetPasswordMutation'
import { ApolloClient, gql, TypedDocumentNode } from '@apollo/client'

const mutation: TypedDocumentNode<
  SetPasswordMutation,
  SetPasswordMutationVariables
> = gql`
  mutation SetPasswordMutation($input: SetPasswordInput!) {
    setPassword(input: $input) {
      status
    }
  }
`

export function setPasswordMutation(
  apolloClient: ApolloClient,
  options: Omit<
    ApolloClient.MutateOptions<
      SetPasswordMutation,
      SetPasswordMutationVariables
    >,
    'mutation'
  >
) {
  return apolloClient.mutate({
    optimisticResponse: {
      setPassword: {
        __typename: 'SetPasswordPayload',
        status: 'ok'
      }
    },
    mutation,
    ...options
  })
}
